import PropTypes from 'prop-types';
import React from 'react';
import {
  Button,
  ReservationSummary,
  ReservationSummaryImage,
  TranslationProvider,
  getTranslation,
} from '@resy/ui-kitchen';

import './ReservationCancel.scss';

const ReservationCancel = ({
  cancelReservation,
  seats,
  tableType,
  timeslot,
  backgroundImage,
  venue,
  cancellationPolicy,
  loading,
}) => {
  let cancelationPolicyKey = 0;

  return (
    <div className="ReservationCancel">
      <div className="ReservationCancel__card">
        {backgroundImage
        && (
          <ReservationSummaryImage
            backgroundImage={backgroundImage}
            card
          />
        )}
        <ReservationSummary
          seats={seats}
          tableType={tableType}
          timeslot={timeslot}
          venue={venue}
        />
      </div>
      <div className="ReservationCancel__content">
        <div className="ReservationCancel__content-container">
          <div
            className="ReservationCancel__content-question"
          >
            <TranslationProvider translationKey="reservation_cancel_confirm">
              <h1
                className="ReservationCancel__content-question-title"
                role="alert"
              >
                Are you sure you want to cancel?
              </h1>
            </TranslationProvider>
          </div>
          <div className="ReservationCancel__content-details">
            {
            cancellationPolicy && cancellationPolicy.map((paragraph) => {
              cancelationPolicyKey += 1;
              return (
                <p key={cancelationPolicyKey}>{paragraph}</p>
              );
            })
          }
          </div>
        </div>
      </div>
      {loading
        && (
          <div
            role="alert"
            aria-label={getTranslation({
              translationKey: 'communication_loading_message',
              fallback: 'Loading...',
            })}
          />
        )}
      <div className="ReservationCancel__ctas">
        <TranslationProvider translationKey="button_cancel">
          <Button
            lg
            onClick={cancelReservation}
            variant="cancel"
            disabled={loading}
            processing={loading}
            data-test-id="reservation_cancel-button-cancel"
            aria-label={getTranslation({
              translationKey: 'button_cancel',
              fallback: 'Cancel',
            })}
          >
            Cancel
          </Button>
        </TranslationProvider>
      </div>
    </div>
  );
};

ReservationCancel.propTypes = {
  cancelReservation: PropTypes.func,
  seats: PropTypes.number.isRequired,
  tableType: PropTypes.string.isRequired,
  timeslot: PropTypes.shape({
    date: PropTypes.string,
    time: PropTypes.string,
  }).isRequired,
  backgroundImage: PropTypes.string,
  venue: PropTypes.string.isRequired,
  cancellationPolicy: PropTypes.arrayOf(PropTypes.string),
  loading: PropTypes.bool,
};

ReservationCancel.defaultProps = {
  cancelReservation: () => {},
  backgroundImage: null,
  cancellationPolicy: [],
  loading: false,
};

export default ReservationCancel;
